import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import { BUTTON_VARIANT } from 'constants/interfaces';
import { formatTextTitle } from 'utils/formatText';

import type IErrorDetailModal from './interfaces/IErrorDetailModal';

import styles from './scss/ErrorDetailModal.module.scss';

function ErrorDetailModal({
  open,
  onClose,
  errorDetails,
  handleGoLink,
}: IErrorDetailModal) {
  const { t } = useTranslation();
  const { error, params } = errorDetails || {};
  return (
    <Modal
      open={open}
      title={error || ''}
      className={styles.modalContainer}
      isButtonsVisible={false}
      onClose={onClose}
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <p>{t('materialityAssessment.titleShort')}</p>
          <p>{t('materialityAssessment.status')}</p>
        </div>
        {params && params.length > 0 ? (
          <div className={styles.errorDetailsList}>
            {params.map((param) => (
              <div
                key={[param.id, param.title, param.status].join('_')}
                className={styles.errorDetailsItem}
              >
                <Button
                  title={param.title}
                  variant={BUTTON_VARIANT.ghost}
                  className={styles.button}
                  onClick={() => handleGoLink(param.id)}
                />
                <p className={clsx(styles.status, styles[param.status])}>
                  {formatTextTitle(param.status, true)}
                </p>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </Modal>
  );
}

export default ErrorDetailModal;
